export const oscilloscopeSettings = {
    width: 450,
    smallWidth: 300,
    largeWidth: 512,
    minDecibels: -90,
    maxDecibels: -1,
    smoothingTimeConstant: 0.8,
    fftSize: 2048,
    scanColour: "#01dd01",
    margin: 0,
    padding: 0,
    border: "3px solid black",
    backgroundColour: "#012501",
    borderRadius: "5px"
}

export const DragAndDropSettings = {
    maxWidth: "250px",
    maxHeight: "100px",
    bgColour: "#012401",
    hoverColour: "grey",
    margin: "5px",
    padding: "30px",
    borderRadius: "5px", 
    border: "3px solid black",
}

export const waveformSettings = {
    height: 90,
    waveColour: "#01dd01",
    progressColour: "black",
    cursorColor: "black",
    bgColour: "#012401",
}

export const boxShadow = "0 0 15px rgba(0, 0, 0, 0.3)";

export const border = "3px solid black";